import { request } from './client';
import ApiConfig from '../constants/api';

export function loginUser(params) {  
  return Promise.resolve(request(ApiConfig.LOGIN, 'post', params));
}

export function getContacts() {  
  return Promise.resolve(request(ApiConfig.CONTACT_LIST, 'GET'));
}

export function getDetailContact(id){
  return Promise.resolve(request(ApiConfig.DETAIL_CONTACT + '/' + id, 'GET'));
}

export function createContact(params) {
  return Promise.resolve(request(ApiConfig.CREATE_CONTACT, 'POST', params));
}

export function updateContact(id, params) {
  return Promise.resolve(request(ApiConfig.UPDATE_CONTACT + '/' + id, 'PUT', params))
}

export function removeContact(id) {
  return Promise.resolve(request(ApiConfig.REMOVE_CONTACT + '/' + id, 'DELETE'))
}

export function sendTestEmail(id) {
  return Promise.resolve(request(ApiConfig.SEND_MAIL_TEST_TO_CONTACT + '/' + id, 'POST'))
}

export function getUsers() {  
  return Promise.resolve(request(ApiConfig.USER_LIST, 'GET'));
}

export function getDetailUser(id){
  return Promise.resolve(request(ApiConfig.DETAIL_USER + '/' + id, 'GET'));
}

export function createUser(params) {
  return Promise.resolve(request(ApiConfig.CREATE_USER, 'POST', params));
}

export function updateUser(id, params) {
  return Promise.resolve(request(ApiConfig.UPDATE_USER + '/' + id, 'PUT', params))
}